// Advanced Economics domain types — mirror of sauron backend schemas (doc 13 + 15).
// Ported verbatim from sauron/frontend/src/domain/advanced_economics/types.ts.

export type TemplateId = 'steady_state' | 'stabilizing' | 'launch';

export const TACOS_PRESETS: Record<TemplateId, number> = {
    steady_state: 12,
    stabilizing: 18,
    launch: 28,
};

export const TEMPLATE_LABELS: Record<TemplateId, string> = {
    steady_state: 'Steady Growth',
    stabilizing: 'Stabilizing',
    launch: 'Launch',
};

export type TacosZone = {
    lo: number;
    hi: number;
    label: string;
};

export const TACOS_ZONES: Record<TemplateId, TacosZone[]> = {
    steady_state: [
        { lo: 0, hi: 12, label: 'Efficient' },
        { lo: 12, hi: 20, label: 'Elevated' },
        { lo: 20, hi: 35, label: 'Aggressive PPC' },
        { lo: 35, hi: 101, label: 'Extreme' },
    ],
    stabilizing: [
        { lo: 0, hi: 15, label: 'Low for stage' },
        { lo: 15, hi: 25, label: 'Normal stabilizing' },
        { lo: 25, hi: 40, label: 'Aggressive scaling' },
        { lo: 40, hi: 101, label: 'Extreme' },
    ],
    launch: [
        { lo: 0, hi: 20, label: 'Too low for launch' },
        { lo: 20, hi: 35, label: 'Normal launch' },
        { lo: 35, hi: 50, label: 'Aggressive launch' },
        { lo: 50, hi: 101, label: 'Extreme / Blitz' },
    ],
};

export type ScenarioInput = {
    slotId: string; // "s1" | "s2" | "s3"
    templateId: TemplateId;
    tacosPercent: number | null; // null → use preset
    tacosCustom: boolean;
    sellPrice: number;
    referralFeeRate: number;
    fbaFixedFee: number;
    returnsRate: number;
    returnsRecoveryRate: number;
    cogs: number | null;
    otherExpenses: number | null; // extra cost per unit
    otherExpensesMode: 'per_unit' | 'percent'; // whether amount is $fixed or % of sell price
    advertisingEnabled: boolean;
    unitsSoldOnThisScenario: number | null;
    compareAgainstLeft: boolean;
};

export type ScenarioOutputMetrics = {
    advertisingCostPerUnit: number;
    returnsCostPerUnit: number;
    otherExpensesCostPerUnit: number;
    amazonFeesAtCurrentPrice: number;
    profitPerUnit: number;
    netMarginPercent: number;
    roiOnCogsPercent: number;
    displayedBreakEvenPrice: number | null;
    breakEvenAcosPercent: number;
    breakEvenSafeFallback: boolean;
    estimatedTotalProfit: number | null;
    tacosEffectivePercent: number;
    tacosZoneId: string;
    tacosIsCustom: boolean;
};

export type ScenarioDelta = {
    profitPerUnitDelta: number;
    netMarginDelta: number;
    roiDelta: number;
    advertisingCostDelta: number;
};

export type ScenarioResult = {
    slotId: string;
    templateId: TemplateId;
    label: string;
    metrics: ScenarioOutputMetrics;
    deltaVsLeft: ScenarioDelta | null;
};
